<template>
  <div class="partner-page">
    <Header />
    
    <div class="partner-container">
      <!-- 介绍文字 -->
      <div class="partner-introduction">
        <h2 class="section-title">合作伙伴</h2>
        <p class="intro-text">
          chmura云通讯自2010年成立以来，始终专注于为企业提供高效、稳定、安全的云通讯解决方案，凭借卓越的技术实力和优质的服务体验，经过十余年的稳健发展，已成功与超过2000家企业建立了长期稳定的战略合作关系。这些合作伙伴遍布全国31个省份和直辖市，从北京、上海、广州等一线城市到新疆、西藏、青海等偏远地区，我们的服务网络覆盖全国每一个角落，为各地区企业数字化转型提供有力支持。合作领域广泛涵盖金融、教育、医疗、制造、零售、物流、政府、能源、交通、传媒等十余个行业，形成了多元化、多层次的客户生态系统。我们的解决方案已在超过500个城市落地应用，日均处理通讯请求超过10亿次，为企业数字化运营提供了坚实的技术保障。
        </p>
        <p class="intro-text">
          我们的客户群体层次丰富，既有世界500强企业如工商银行、中国移动、华为、建设银行、中国电信等行业巨头，也有阿里巴巴、腾讯、字节跳动、美团、拼多多等知名互联网公司，同时还包括国家电网、中国石油、中国石化、中国铁路等大型国有企业，以及众多快速成长的科技创新型创业公司。以金融行业为例，我们为工商银行开发的智能客服系统，实现了95%以上的客户问题自动解答，客户满意度提升30%，年节约运营成本超过2亿元。在教育领域，我们与北京大学合作打造的远程教学平台，支持10万人同时在线互动，覆盖全国2000多所高校，极大推动了优质教育资源的普及。通过与这些不同规模、不同领域的优秀企业深度合作，我们不仅积累了丰富的行业经验，更从中汲取创新灵感，持续优化产品功能和服务体系，不断提升技术创新能力，为客户创造更大的商业价值和竞争优势。
        </p>
        <p class="intro-text">
          在每一次合作过程中，我们始终坚持"以客户为中心"的核心服务理念，组建专业的行业顾问团队，深入调研每个行业的独特特点和个性化需求，为客户提供量身定制的一站式解决方案。我们的服务团队成员平均拥有8年以上的行业经验，其中博士、硕士占比超过40%，具备深厚的技术背景和丰富的项目实施经验。针对大型企业客户，我们设立专属的客户成功经理，提供一对一的全程跟踪服务；对于中小企业客户，我们开发了标准化的解决方案包，确保快速部署和低成本接入。我们建立了完善的服务响应机制，能够7×24小时快速响应客户需求，提供从方案设计、部署实施到后期运维的全生命周期服务，确保每个项目的服务质量和交付效率。此外，我们每年投入超过10%的营收用于研发创新，拥有150余项自主知识产权专利，其中5G通讯技术、AI智能客服、区块链安全加密等核心技术处于行业领先水平。
        </p>
        <p class="intro-text">
          为了构建更加紧密的合作伙伴生态系统，我们推出了"chmura合作伙伴计划"，分为技术合作伙伴、渠道合作伙伴、行业解决方案合作伙伴三个类别，为不同类型的合作伙伴提供差异化的支持政策。技术合作伙伴可获得我们的API接口和技术文档，共同开发行业解决方案；渠道合作伙伴可享受优惠的代理折扣和市场支持；行业解决方案合作伙伴可与我们共建联合实验室，共享研发资源。目前，已有超过500家企业加入我们的合作伙伴计划，形成了优势互补、互利共赢的产业生态。我们定期举办合作伙伴大会，分享行业趋势和技术创新成果，促进合作伙伴之间的交流与合作。此外，我们还建立了合作伙伴培训体系，为合作伙伴提供技术认证、销售技巧等方面的培训，帮助他们提升服务能力和市场竞争力。
        </p>
        <p class="intro-text">
          展望未来，我们将继续秉持开放合作的态度，积极扩大全球合作伙伴网络，不仅深耕国内市场，还将拓展东南亚、欧洲、北美等海外市场，与更多国际知名企业建立战略合作关系。同时，我们将加强与各行业客户的深度融合，通过共建联合创新实验室、开展行业标准制定等方式，共同推动数字化转型和智能通讯技术的创新发展。我们计划在未来三年投入50亿元用于研发，重点布局6G通讯技术、元宇宙通讯、量子加密通讯等前沿领域，为客户提供更加先进、安全、智能的云通讯解决方案。我们相信，凭借持续的技术创新、优质的客户服务和开放的合作精神，chmura云通讯必将成为更多企业值得信赖的云通讯合作伙伴，携手共创数字经济新时代。
        </p>
      </div>
    </div>
    
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'
import { partnerCompanies } from './config.js'

export default {
  name: 'Partner',
  components: {
    Header,
    Footer,
    BackToTop
  },
  data() {
    return {
      // 存储生成的图片URL，避免重复生成
      imageCache: []
    }
  },
  methods: {
    // 生成随机图片URL
    getRandomImage() {
      if (this.imageCache.length < 40) {
        const width = 80;
        const height = 80;
        const imageUrl = `https://picsum.photos/seed/${Date.now() + this.imageCache.length}/${width}/${height}`;
        this.imageCache.push(imageUrl);
        return imageUrl;
      }
      return this.imageCache[Math.floor(Math.random() * this.imageCache.length)];
    },
    // 生成随机公司名称
    getRandomCompanyName() {
      const randomIndex = Math.floor(Math.random() * partnerCompanies.length);
      return partnerCompanies[randomIndex];
    },
    // 处理图片加载错误
    handleImageError(event) {
      console.error('图片加载失败:', event);
    }
  }
}
</script>

<style scoped>
.partner-page {
  padding-top: 80px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.partner-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.partner-introduction {
  background-color: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
  background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.intro-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #606266;
  margin-bottom: 16px;
  text-align: justify;
}

.partner-photo-wall {
  background-color: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.section-subtitle {
  font-size: 1.8rem;
  font-weight: bold;
  color: #303133;
  margin-bottom: 30px;
  text-align: center;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 20px;
  justify-items: center;
}

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
}

.partner-item:hover {
  background-color: #f0f9ff;
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
}

.partner-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 8px;
  border: 2px solid #e4e7ed;
  transition: all 0.3s ease;
}

.partner-item:hover .partner-image {
  border-color: #409EFF;
  transform: scale(1.1);
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.5);
}

.partner-name {
  font-size: 0.9rem;
  color: #606266;
  text-align: center;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .partner-introduction,
  .partner-photo-wall {
    padding: 20px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1.5rem;
  }
  
  .intro-text {
    font-size: 1rem;
  }
  
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 10px;
  }
  
  .partner-image {
    width: 35px;
    height: 35px;
  }
  
  .partner-name {
    font-size: 0.8rem;
  }
}
</style>